import { css, styled } from "@mui/material";

import { getColor } from "@hooks";
import { cssForHeaderWithLinearGradient, cssPropertiesToString } from "@utils";

import {
  pageGapDesktop,
  pageGapDesktopXl,
  pageGapMobile,
  pageGapTablet,
  pageMarginY,
} from "./layoutConstants";

export const ContactSectionContainer = styled("div")(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    ${theme.breakpoints.up("mobile")} {
      gap: 16px;
      margin: ${pageGapMobile} 16px;
    }

    ${theme.breakpoints.up("tablet")} {
      gap: 24px;
      margin: ${pageGapTablet} 64px;
    }

    ${theme.breakpoints.up("desktop")} {
      flex-direction: row;
      gap: 48px;
      margin: ${pageGapDesktop} 48px;
    }

    ${theme.breakpoints.up("desktopXl")} {
      margin: ${pageGapDesktopXl} 48px;
    }
  `,
);

export const QuestionsList = styled("ul")(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 8px;

    padding: 0;

    ${pageMarginY(theme)}
  `,
);

const QuestionContainerCommonStyles = styled("div")(
  ({ theme }) => css`
    padding: 16px;

    color: ${getColor(c => c.tokens.text["sub-600"], theme)};
    background: ${getColor(c => c.tokens.bg["white-0"], theme)};

    border: 1px solid ${getColor(c => c.tokens.stroke["soft-200"], theme)};
    border-radius: 4px;
  `,
);

export const QuestionContainer = styled(QuestionContainerCommonStyles)(
  ({ theme }) => css`
    flex-grow: 1;

    ${theme.breakpoints.up("mobile")} {
      ${cssPropertiesToString(theme.typography.paragraph_medium_medium)}
    }

    ${theme.breakpoints.up("desktop")} {
      ${cssPropertiesToString(theme.typography.paragraph_xxlarge_semibold)}
    }
  `,
);

export const AnswerText = styled("div")(
  ({ theme }) => css`
    margin-top: 12px;

    ${theme.breakpoints.up("mobile")} {
      ${cssPropertiesToString(theme.typography.paragraph_small_regular)}
      color: ${getColor(c => c.tokens.text["sub-600"], theme)};
    }

    ${theme.breakpoints.up("desktop")} {
      ${cssPropertiesToString(theme.typography.paragraph_medium_regular)}
      color: ${getColor(c => c.tokens.text["sub-600"], theme)};
    }
  `,
);

export const QuestionCountContainer = styled(QuestionContainerCommonStyles)(
  ({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;

    width: 66px;
    flex-shrink: 0;
    ${cssPropertiesToString(theme.typography.heading_h6_medium_desktop)}
  `,
);

export const CaseStudiesSection = styled("div")(
  ({ theme }) => css`
    ${pageMarginY(theme)}

    display: flex;
    flex-direction: column;
    gap: 16px;
  `,
);

export const CaseStudiesHeader = styled("p")(
  ({ theme }) => css`
    ${cssForHeaderWithLinearGradient(theme)}

    ${theme.breakpoints.up("mobile")} {
      ${cssPropertiesToString(theme.typography.heading_h3_bold_tablet)}
    }

    ${theme.breakpoints.up("desktop")} {
      ${cssPropertiesToString(theme.typography.heading_h3_bold_desktop)}
    }
  `,
);

export const CaseStudiesSubheader = styled("p")(
  ({ theme }) => css`
    ${theme.breakpoints.up("mobile")} {
      ${cssPropertiesToString(theme.typography.paragraph_medium_medium)}
    }

    ${theme.breakpoints.up("desktop")} {
      ${cssPropertiesToString(theme.typography.paragraph_medium_regular)}
    }
  `,
);

export const CaseStudiesContainer = styled("div")(
  ({ theme }) => css`
    display: flex;

    ${theme.breakpoints.up("mobile")} {
      flex-direction: column;
      gap: 16px;
    }

    ${theme.breakpoints.up("tablet")} {
      flex-direction: row;
      gap: 24px;
    }
  `,
);
